import { usePage } from "@inertiajs/react"
import React from "react"
import { IntercomDisabledAlert } from "./components/intercom-disabled-alert"
import { AdwordsConversionScript } from "./scripts/adwords-conversion"
import { reportAndReload } from "./layout-config-sentry-context"

class InertiaPageFooterErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  componentDidCatch(error, info) {
    const reloading = reportAndReload(error, info, this.props.pageContext)
    if (!reloading) {
      this.setState({ hasError: true })
    }
  }

  render() {
    if (this.state.hasError) return null
    return this.props.children
  }
}

export function InertiaPageFooter() {
  const page = usePage()
  const {
    props: { layoutConfig }
  } = page

  const pageContext = {
    layoutConfig,
    url: page.url,
    component: page.component,
    version: page.version
  }

  return (
    <InertiaPageFooterErrorBoundary pageContext={pageContext}>
      <InertiaPageFooterContent layoutConfig={layoutConfig} />
    </InertiaPageFooterErrorBoundary>
  )
}

function InertiaPageFooterContent({ layoutConfig }) {
  return (
    <>
      {layoutConfig.components.intercomDisabledAlert.visible && (
        <IntercomDisabledAlert />
      )}

      {layoutConfig.components.adwordsScript.visible && (
        <AdwordsConversionScript
          {...layoutConfig.components.adwordsScript.data}
        />
      )}
    </>
  )
}
